export default __webpack_public_path__ + "static/media/E05.5f88d656.mp3";